import { useTemplateContext } from "shared/app/VerificationTemplate/provider";
import { RangeSlider } from "./RangeSlider";
import { SettingCard } from "../../../../../components/SettingCard";

export const Header = () => {
  const { template, setTemplate, readOnly } = useTemplateContext();
  if (!template?.screening_criteria) return null;
  return (
    <SettingCard title="Recommendation settings">
      <div className="mt-[54px]">
        <RangeSlider
          ranges={[
            template.screening_criteria.decline_range_end || 4,
            template.screening_criteria.conditional_approval_range_end || 7
          ]}
          setRanges={(ranges) => {
            if (!template.screening_criteria) return;

            setTemplate({
              ...template,
              screening_criteria: {
                ...template.screening_criteria,
                decline_range_end: ranges[0],
                conditional_approval_range_start: ranges[0] + 0.1,
                conditional_approval_range_end: ranges[1],
                approval_range_start: ranges[1] + 0.1
              }
            });
          }}
          disabled={readOnly}
        />
      </div>
    </SettingCard>
  );
};
